// export const environment = {
//   production: false,
//   authUrl:
//     "https://openapi.taxes.gov.il/shaam/tsandbox/longtimetoken/oauth2/authorize",
//   tokenUrl:
//     "https://openapi.taxes.gov.il/shaam/tsandbox/longtimetoken/oauth2/token",
//   apiUrl: "https://intg.thinvoices.com/oauth/authorization-code",
//   // DEV
//    baseUrl: "https://devb.thinvoices.com/",
//   // local
// //  baseUrl: "http://localhost:8000/",
//   PdfbaseUrl: "https://thinvoice.s3.amazonaws.com/files-dev/merchants",
//   expenseAnalysisTokensPerDocument: 5,

//   /** Firebase Web SDK (client config — safe to ship in frontend). Project: thinvoices-614df */
//   firebase: {
//     apiKey: 'AIzaSyDyqGjYH6Ks2PjMoVAQg9OmRwGKTDfDC_0',
//     authDomain: 'thinvoices-614df.firebaseapp.com',
//     projectId: 'thinvoices-614df',
//     storageBucket: 'thinvoices-614df.firebasestorage.app',
//     messagingSenderId: '808330083630',
//     appId: '1:808330083630:web:daa53fa3fcf58bef38cebf',
//   },

//   /**
//    * Firebase Console → Project settings → Cloud Messaging → Web Push certificates → Key pair.
//    * Required for FCM `getToken()`. Generate once in console, then paste the public key here.
//    */
//   firebaseWebPushVapidKey:
//     'BHXm2Rkr1VzGrj1x40HPdhHRHHeEpTnDs_v1JI9bruT5s_dpcRYEjunRvabiVu7zwxYAiPE8JoHmUcvlsrF7VNU',

//   /** External demo video for campaign landing «Watch how THI works» CTA */
//   campaignDemoVideoUrl: '',
// };

// prod
export const environment = {
  production: false,
  authUrl:
    "https://openapi.taxes.gov.il/shaam/tsandbox/longtimetoken/oauth2/authorize",
  tokenUrl:
    "https://openapi.taxes.gov.il/shaam/tsandbox/longtimetoken/oauth2/token",
  apiUrl: "https://intg.thinvoices.com/oauth-prod/authorization-code",
  baseUrl: "https://sub.thinvoices.com/",
  PdfbaseUrl: "https://thinvoice.s3.amazonaws.com/files/merchants",
  expenseAnalysisTokensPerDocument: 5,
  /** Firebase Web SDK — thinvoices-614df */
  firebase: {
    apiKey: "AIzaSyDyqGjYH6Ks2PjMoVAQg9OmRwGKTDfDC_0",
    authDomain: "thinvoices-614df.firebaseapp.com",
    projectId: "thinvoices-614df",
    storageBucket: "thinvoices-614df.firebasestorage.app",
    messagingSenderId: "808330083630",
    appId: "1:808330083630:web:daa53fa3fcf58bef38cebf",
  },

  /**
   * Firebase Console → Cloud Messaging → Web Push certificates → Key pair.
   */
  firebaseWebPushVapidKey:
    "BHXm2Rkr1VzGrj1x40HPdhHRHHeEpTnDs_v1JI9bruT5s_dpcRYEjunRvabiVu7zwxYAiPE8JoHmUcvlsrF7VNU",
  /** External demo video for campaign landing «Watch how THI works» CTA */
  campaignDemoVideoUrl: "",
};
